import { makeStyles } from '@material-ui/core';
import { Link } from '@backstage/core-components';
import LiveHelp from '@material-ui/icons/LiveHelp';


const useStyles = makeStyles({
  contactSupportBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px 8px',
    fontSize: '14px',
    borderRadius: '4px',
    border: '1px solid var(--arla-support-button-border-color)',
    color: 'var(--arla-text-primary-color)',
    textDecoration: 'none',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: 'var(--arla-anchor-color)',
      color: 'var(--arla-support-button-hover-text-color)',
      textDecoration: 'none',
    },
  }
});

export const ContactSupportButton = ({ text, contactEmail }: { text: string; contactEmail: string }) => {
  const classes = useStyles();

  return (
    <Link to={`mailto:${contactEmail}`} className={classes.contactSupportBtn}>
        <LiveHelp fontSize="inherit" /> {text}
    </Link>
  );
};